import React from 'react'

import { 
    useFormContext, 
    useFieldArray,
    useWatch,
    Controller 
} from 'react-hook-form'

import DatePicker from 'react-datepicker'

import { subYears, addYears } from 'date-fns'

import {
    ErrorText,
    RedTint
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    LeftApplicationDiv,
    RightApplicationDiv,
    FullApplicationDiv,
    ApplicationHeader,
    InputField,
    BodyTextArea, 
    AddButtonDiv, 
    DeleteButtonDiv, 
    AddButton, 
    DeleteButton
} from  '../../../Styles/Components/ApplicationSectionStyles'

import '../../../Styles/CSS/react-datepicker-override.css'

// Redux selector

import { useSelector } from 'react-redux'

import LocationSearchInput from '../../Action/LocationSearchInput'

function ExperienceSection(props) {

    const { register, control, errors } = useFormContext()

    const { fields, append, remove } = useFieldArray({
        control,
        name: "experiences"
    })

    const experiences = useWatch({
        control,
        name: 'experiences',
    });

    const locked = useSelector(state => state.appViewer.locked)

    return (//need to fix default value of calendar
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>Experience</SectionHeader>
            </HeaderDiv>
            {fields.map((item, index) => { 
                return (
                    <FormDiv className="experience-form" key={item.id}>
                        <ApplicationRowDiv>
                            <FullApplicationDiv>
                                <ApplicationHeader>Role or Position<RedTint>*</RedTint></ApplicationHeader>
                                <InputField 
                                    type="text" name={`experiences[${index}].position`} placeholder="Role or Position" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 50,
                                                message: 'exceeds 50 character limit'
                                            },
                                            pattern: {
                                                value: /^[a-zA-Z0-9 ,/;:&()]+$/,
                                                message: 'invalid character usage'
                                            }
                                        })
                                    } 
                                    defaultValue={item.position}
                                    readOnly={locked}
                                />
                                {errors['experiences'] != null && errors['experiences'][index] != null && errors['experiences'][index]['position'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['experiences'][index]['position']['message']}</ErrorText>}
                            </FullApplicationDiv>
                        </ApplicationRowDiv>
                        <ApplicationRowDiv>
                            <LeftApplicationDiv>
                                <ApplicationHeader>Company<RedTint>*</RedTint></ApplicationHeader>
                                <InputField 
                                    type="text" name={`experiences[${index}].company`} placeholder="Company" 
                                    ref={
                                        register({
                                            maxLength: {
                                                value: 50,
                                                message: 'exceeds 50 character limit'
                                            },
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            pattern: {
                                                value: /^[\.@&]?[a-zA-Z0-9 ]+[ !\.@&()]?[ a-zA-Z0-9!()]+$/,
                                                message: 'invalid format or character usage'
                                            }
                                        })
                                    } 
                                    defaultValue={item.company}
                                    readOnly={locked}
                                />
                                {errors['experiences'] != null && errors['experiences'][index] != null && errors['experiences'][index]['company'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['experiences'][index]['company']['message']}</ErrorText>}
                            </LeftApplicationDiv>
                            <RightApplicationDiv>
                                <ApplicationHeader>Location<RedTint>*</RedTint></ApplicationHeader>
                                <Controller
                                    render={(props) => (
                                        <LocationSearchInput
                                            onChange={(value) => {
                                                props.onChange(value)
                                            }}
                                            value={props.value}
                                        />
                                    )}
                                    onChange={(value) => this.handleChange(value)}
                                    name={`experiences[${index}].location`}
                                    errors={errors}
                                    control={control}
                                    defaultValue={item.location}
                                    rules={
                                        { 
                                            required: {
                                                value: true,
                                                message: 'select a location' 
                                            }
                                        }
                                    }
                                />
                                {errors['experiences'] != null && errors['experiences'][index] != null && errors['experiences'][index]['location'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['experiences'][index]['location']['message']}</ErrorText>}
                            </RightApplicationDiv>
                        </ApplicationRowDiv>
                        <ApplicationRowDiv>
                            <LeftApplicationDiv>
                                <ApplicationHeader>Start Date</ApplicationHeader>
                                <Controller
                                    as={
                                        <DatePicker 
                                            wrapperClassName="datePicker"
                                            dateFormat="MM/dd/yyyy"
                                            selected={
                                                typeof experiences[index] !== 'undefined' && experiences[index] !== null && experiences[index]['start_date'] !== null && experiences[index]['start_date'] !== '' ? new Date(experiences[index]['start_date']) : null
                                            } 
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            customInput={<InputField />}
                                            placeholderText="MM/DD/YYYY"
                                            shouldCloseOnSelect
                                            popperPlacement="top"
                                            fixedHeight
                                            minDate={subYears(new Date(), 50)}
                                            maxDate={typeof experiences[index] !== 'undefined' && experiences[index]['end_date'] !== null && experiences[index]['end_date'] !== '' ?  new Date(experiences[index]['end_date']) : addYears(new Date(), 1)}
                                        />
                                    }
                                    errors={errors}
                                    control={control}
                                    register={
                                        register({ 
                                            
                                        })
                                    }
                                    name={`experiences[${index}].start_date`}
                                    defaultValue={
                                        (item.start_date !== null && typeof item.start_date !== 'object') ? new Date(item.start_date) : null
                                    }
                                    readOnly={locked}
                                />
                                {errors['experiences'] != null && errors['experiences'][index] != null && errors['experiences'][index]['start_date'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['experiences'][index]['start_date']['message']}</ErrorText>}
                            </LeftApplicationDiv>
                            <RightApplicationDiv>
                                <ApplicationHeader>End Date</ApplicationHeader>
                                <Controller
                                    as={
                                        <DatePicker 
                                            wrapperClassName="datePicker"
                                            dateFormat="MM/dd/yyyy"
                                            selected={
                                                typeof experiences[index] !== 'undefined' && experiences[index] !== null && experiences[index]['end_date'] !== null && experiences[index]['end_date'] !== '' ? new Date(experiences[index]['end_date']) : null
                                            } 
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            customInput={<InputField />}
                                            placeholderText="MM/DD/YYYY"
                                            shouldCloseOnSelect
                                            popperPlacement="top"
                                            fixedHeight
                                            minDate={typeof experiences[index] !== 'undefined' && experiences[index]['start_date'] !== null && experiences[index]['start_date'] !== '' ? new Date(experiences[index]['start_date']) : subYears(new Date(), 50)}
                                            maxDate={new Date()}
                                        />
                                    }
                                    errors={errors}
                                    control={control}
                                    register={
                                        register({ 
                                            
                                        })
                                    }
                                    name={`experiences[${index}].end_date`}
                                    defaultValue={
                                        (item.end_date !== null && typeof item.end_date !== 'object') ? new Date(item.end_date) : null
                                    }
                                    readOnly={locked}
                                />
                                {errors['experiences'] != null && errors['experiences'][index] != null && errors['experiences'][index]['end_date'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['experiences'][index]['end_date']['message']}</ErrorText>}
                            </RightApplicationDiv>
                        </ApplicationRowDiv>
                        <ApplicationRowDiv>
                            <FullApplicationDiv>
                                <ApplicationHeader>Description</ApplicationHeader>
                                <BodyTextArea 
                                    type="text" name={`experiences[${index}].description`} placeholder="Description" 
                                    ref={
                                        register({

                                        })
                                    } 
                                    defaultValue={item.description}
                                    readOnly={locked}
                                />
                                {errors['experiences'] != null && errors['experiences'][index] != null && errors['experiences'][index]['description'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['experiences'][index]['description']['message']}</ErrorText>}
                            </FullApplicationDiv>
                        </ApplicationRowDiv>
                        {fields.length !== 0 && !locked ? 
                            <DeleteButtonDiv>
                                <DeleteButton type="button" onClick={() => remove(index)}>Delete</DeleteButton>
                            </DeleteButtonDiv> : null
                        }
                    </FormDiv>
                );
            })}
            {!locked ?
                <AddButtonDiv>
                    <AddButton type="button" onClick={() => {append({company: "", position: "", location: "", start_date: null, end_date: null, description: ""})}}>Add Experience</AddButton>
                </AddButtonDiv> : null
            }
        </SectionDiv>
    )
}

export default ExperienceSection;